import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CelebrationIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M20.38 22.994c-.33 0-.67-.06-.98-.17h-.01l-10.63-3.96a3.03 3.03 0 01-1.22-.82c-.33-.37-.57-.83-.68-1.31a2.99 2.99 0 01.77-2.77l6.68-6.68c.39-.37.84-.62 1.33-.74a3.17 3.17 0 011.5 0c.49.13.94.37 1.31.72.37.35.65.79.8 1.26l3.93 10.59c.18.57.2 1.13.06 1.66-.13.53-.41 1.01-.81 1.39a2.984 2.984 0 01-2.05.83zm-.31-2.05c.17.06.34.07.51.03.17-.04.33-.12.46-.24s.21-.28.26-.45c.04-.17.04-.35-.02-.52l-3.93-10.59c-.07-.2-.16-.35-.28-.46a.907.907 0 00-.44-.24 1.005 1.005 0 00-.94.24l-6.65 6.65a.91.91 0 00-.23.42c-.04.16-.05.33 0 .49a.999.999 0 00.64.7l10.64 3.97h-.02zM4.13 13.225c-.35 0-.69-.18-.87-.51a.994.994 0 01.39-1.36c.92-.52 2-.67 3.03-.44.54.12.88.66.75 1.2-.12.54-.66.88-1.2.75a2.29 2.29 0 00-1.62.23c-.15.09-.32.13-.49.13h.01zm3.629-4.541c-.32 0-.64-.16-.83-.45-.59-.88-.83-1.95-.68-3 .08-.55.58-.93 1.13-.85.55.08.93.58.85 1.13-.08.57.05 1.14.37 1.62.31.46.18 1.08-.28 1.39-.17.11-.36.17-.55.17l-.01-.01zm3.871-.45c-.39 0-.76-.23-.92-.62a8.498 8.498 0 01-.23-5.92c.17-.52.73-.81 1.26-.64.52.17.81.74.64 1.26-.48 1.48-.42 3.09.18 4.53a1.004 1.004 0 01-.92 1.39h-.01zm-9.17-.349c-.47 0-.94-.19-1.27-.53-.34-.34-.52-.79-.52-1.27s.19-.94.53-1.27c.67-.67 1.86-.67 2.54 0 .33.33.53.8.53 1.27s-.19.93-.53 1.27c-.34.34-.79.53-1.27.53h-.01z"
                    })
                })
            })
        ]
    });
};
CelebrationIcon.isCarinaIcon = true;
export default CelebrationIcon;
